import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import Regex from 'services/utils/regex/Regex';

const createTicketInputs = {
  site_id: '',
  remarks: '',
  attachment: '',
};

const EmpCreateTicketForm = ({
  createTicketSubmit,
  documentUploadUrl,
  documentUrlData,
  sitesList = [],
}) => {
  const [createTicketData, setCreateTicketData] = useState(createTicketInputs);
  const [className, setClassName] = useState('empty');

  const onBlur = () => {
    if (createTicketData.remarks) setClassName('');
    else setClassName('empty');
  };

  const createTicketHandle = () => {
    let isValue = true;
    for (const key in createTicketData) {
      if (key !== 'attachment') {
        if (!createTicketData[key]) {
          isValue = false;
        }
      }
    }
    isValue ? createTicketSubmit(createTicketData) : createTicketSubmit(null);
  };

  useEffect(() => {
    createTicketHandle();
  }, [createTicketData]);

  return (
    <form className="create-ticket-form">
      <DropDownInput
        label={localization.selectSiteName}
        data={sitesList}
        required
        isStarRequired={true}
        errorMsg={localization.requiredSiteName}
        getIdValue={(val) =>
          setCreateTicketData({ ...createTicketData, site_id: val.id })
        }
      />

      <TextAreaInput
        type="text"
        rows={4}
        label={localization.remarks}
        className={`${className} inline-css scrollbar-styling`}
        onBlur={onBlur}
        inputValue={createTicketData?.remarks}
        regex={Regex.text.test(createTicketData.remarks)}
        errorMsg={localization.requiredRemark}
        required
        isStarRequired={true}
        handleChange={(e) => {
          setCreateTicketData({
            ...createTicketData,
            remarks: e.target.value,
          });
        }}
      />

      <div className="form-group form-btn">
        <FileUpload
          id="addReplyAttachment"
          multiple="multiple"
          accept=".pdf,.png,.jpg,.jpeg,.doc"
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          onChange={(val) =>
            setCreateTicketData({
              ...createTicketData,
              attachment: val,
            })
          }
        >
          <span className="btn btn-transparent">
            {localization.uploadMultiAttachment}
          </span>
        </FileUpload>
      </div>
    </form>
  );
};

export default EmpCreateTicketForm;
